import { render, staticRenderFns } from "./sql-editor.vue?vue&type=template&id=30cf484e&scoped=true&"
import script from "./sql-editor.vue?vue&type=script&lang=js&"
export * from "./sql-editor.vue?vue&type=script&lang=js&"
import style0 from "./sql-editor.vue?vue&type=style&index=0&id=30cf484e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cf484e",
  null
  
)

export default component.exports